export enum EEmploymentStatus {
  LEAVE = "leave",
  LIVE = "live",
  TERMINATED = "terminated",
}
